<template>
  <div class="box">
    <div class="box-top vs-column vs-align-center">
      <div class="box-top-title vs-row vs-align-center vs-space-between">
        <div class="vs-column box-top-title-content">
          <div class="font-weight width-100 text-left font-36 color-black3 margin-bottom-30">广西法网·桂法通APP</div>
          <div class="width-100 text-left font-28 color-92 margin-bottom-20">广西法网手机客户端</div>
          <div class="width-100 text-left font-22 color-92 margin-bottom-30">您扫码下载、注册，即可获得高效便捷、 智能精准的法律服务。</div>
          <img class="QRcode" src="../assets/img/QRcode.png">
        </div>
        <img src="../assets/img/Image.png">
      </div>
      <div class="box-top-title-text-title font-32 color-black3 margin-bottom-25">APP介绍</div>
      <div class="box-top-title-text-content font-16 color-92"> “广西法网·桂法通”APP是依托广西法律服务网开发的首个移动手机客户端。为打造集“法律咨询、司法行政诉求”为一体的“老百姓身边的法律助手”APP，逐步推行所有法律服务事项网上咨询、查询、受理、办理，最终实现“数据多跑路、群众少跑腿”的智慧法律服务，为人民群众提供全业务、全时空的公共法律服务。
        “广西法网·桂法通”APP整合了法律咨询、法律服务机构和人员信息查询、司法行政业务办理、普法宣传等各项司法行政业务，免费提供24小时热线咨询、留言解答、智能解答，在线申办法律援助、公证等业务。为群众提供扫码可得、优质高效、智能精准的公共法律服务。</div>
    </div>
    <div class="box-bottom vs-column vs-align-center">
      <div class="box-top-title-text-title font-32 color-black3 margin-bottom-40">项目展示</div>
      <div class="box-top-title-text-swiper margin-bottom-30">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide class="benefitBox" v-for="(item, index) in list" :key="index">
            <div class="box1" :style="{backgroundImage: 'url(' + item.img + ')', backgroundSize:'100% 100%'}" ></div>
          </swiper-slide>
          <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      <div class="pagin-box vs-row vs-space-center">
        <div v-for="(item, index) in 6" :key="index" class="pagin" :class="index===index1?'pagin-active':''"></div>
      </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      const self = this
      return {
        list: [
           {img: require('@/assets/img/img7.jpg')},
           {img: require('@/assets/img/img8.jpg')},
           {img: require('@/assets/img/img9.jpg')},
           {img: require('@/assets/img/img10.jpg')},
           {img: require('@/assets/img/img11.jpg')},
           {img: require('@/assets/img/img12.jpg')},
         ],
        index1: 2,
        swiperOption: {
          autoplay: true,
          slidesPerView: 4.1,
          centeredSlides: true,
          // loop: true,
          initialSlide :2,
          touchRatio: 1, //触摸距离与slide滑动距离的比率。
          spaceBetween: 0,
          on:{
            // 使用es6的箭头函数，使this指向vue对象
            slideChangeTransitionEnd: function(swiper,event){
              self.index1 = swiper.activeIndex
              self.$forceUpdate()
            },
          }
        }
      }
    },
    computed: {
      swiper() {
        let width = 1920
        width = document.documentElement.clientWidth;
        if(width*1 < 1520*1) {
          this.swiperOption.slidesPerView = 3.2
        }else if(width*1 < 1700*1) {
          this.swiperOption.slidesPerView = 3.6
        }else {
          this.swiperOption.slidesPerView = 4.1
        }
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .color-92 {
  color: #929292;
}
.box {
    width: 100%;
    /*min-width: 920px;*/
  font-family: "Microsoft YaHei"!important;
  }
.box-top{
  width: 100%;
  height: 923px;
  background-image: url("../assets/img/bg3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 106px 390px 80px;
}
.box-bottom {
  width: 100%;
  margin-top: 80px;
  background-color: #fafdfe;
  padding-top: 50px;
  padding-bottom: 60px;
}
  .box-top-title {
    width: 100%;
    margin-bottom: 103px;
  }
  .box-top-title-content  {
    width: 400px;
  }
  .text-left {
    text-align: left;
  }
  .QRcode {
    width: 200px;
    height: 200px;
  }
  .box-top-title-text-title {
    width: 144px;
    height: 74px;
    line-height: 74px;
    background-image: url("../assets/img/title-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .box-top-title-text-content {
    line-height: 35px;
    text-align: left;
    text-indent: 40px;
  }
  .box-top-title-text-swiper {
    width: 100%;
    height: 900px;
  }
.box-top-title-text-swiper .box1 {
  /*width: 407;*/
  /*height: 716px;*/
  width: 440px;
  height: 790px;
  border-radius: 5px;
  background-color: rgb(192, 192, 192);
  box-shadow: 0px 0px 15px 0px rgba(165, 165, 165, 0.3);
}
.benefitBox {
  width: 494px!important;
}
.box-top-title-text-swiper .swiper-slide:not(.swiper-slide-active) {
  transition: 400ms;
  transform: scale(0.85);
}
.swiper-slide{
  width: 390px!important;
}
.swiper-slide-active{
  width: 438px!important;
  height: 808px;
}
.swiper-slide-active .box1{
  width: 490px!important;
  height: 830px;
}
.swiper-slide-prev{
  width: 438px!important;
  height: 808px;
}
.swiper-slide-prev .box1{
  width: 438px!important;
  height: 808px;
}
.swiper-slide-next{
  width: 438px!important;
  height: 808px;
}
.swiper-slide-next .box1{
  width: 438px!important;
  height: 808px;
}
  .font-weight {
    font-weight: bold;
  }
  .pagin-box {
    width: 100%;
    height: 30px;
  }
  .pagin {
    background-color: rgb(212, 212, 212);
    width: 20px;
    height: 10px;
    margin: 10px 6px;
    border-radius: 8px;
  }
  .pagin-active {
    background-color: rgb(15, 123, 255);
    width: 30px;
    height: 10px;
  }


  @media (max-width: 1800px) {
    .box-top {
      padding: 106px 180px 80px;
    }
  }
  @media (max-width: 1520px) {
    .box-top {
      padding: 106px 130px 80px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/gftAPP.vue